export default __webpack_public_path__ + "static/media/med7.b19595fd.png";